/** Serialize WebGPU setup/teardown per canvas (avoids StrictMode / HMR races). */

const canvasTurn = new WeakMap<HTMLCanvasElement, Promise<void>>();

export async function waitForCanvasGpuTurn(
  canvas: HTMLCanvasElement,
): Promise<() => void> {
  const prev = canvasTurn.get(canvas) ?? Promise.resolve();
  let release!: () => void;
  const turn = new Promise<void>((resolve) => {
    release = resolve;
  });
  canvasTurn.set(
    canvas,
    prev.then(() => turn),
  );
  await prev;
  return release;
}

export function clearCanvasGpuTurn(
  _canvas: HTMLCanvasElement,
  release: () => void,
): void {
  release();
}
